var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10187",
    "data-name": "Group 10187",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.281,
    height: 11.109,
    viewBox: "0 0 14.281 11.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 14.281,
    height: 11.109,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M5.554,11.109a.794.794,0,0,0,.561-1.354L2.709,6.348H13.488a.794.794,0,0,0,0-1.587H2.709L6.114,1.354A.793.793,0,0,0,4.993.233L.233,4.994a.778.778,0,0,0-.171.256.787.787,0,0,0,0,.609.778.778,0,0,0,.171.256l4.76,4.761a.787.787,0,0,0,.561.233",
    transform: "translate(0 0)",
    fill: "#152c40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBackArrow);
export default __webpack_public_path__ + "static/media/filter_back_arrow.649b54597d12be38001efd578f45290a.svg";
export { ForwardRef as ReactComponent };